<template>
  <div class="tickets">
    <table>
      <tr class="table-header line">
        <th>موضوع</th>
        <th>بخش</th>
        <th class="mobilehidden">زمان</th>
        <th class="mobilehidden">وضعیت</th>
        <th>مشاهده</th>
      </tr>
      <tr v-for="(ticket, index) in tickets" :key="index">
        <td>{{ ticket.subject }}</td>
        <td>{{ typeLabel(ticket.type) }}</td>
        <td class="mobilehidden">
          {{ $G2J(ticket.createdAtDateTime, "faDateTime") }}
        </td>
        <td class="mobilehidden" :style="{ color: statusColor(ticket.status) }">
          {{ statusLabel(ticket.status) }}
        </td>
        <td>
          <a @click.prevent="goto(ticket.id)">
            <inline-svg :src="require('@/assets/icons/eye.svg')" width="24" />
          </a>
        </td>
      </tr>
    </table>
    <pagination
      :key="lastPage"
      v-if="lastPage > 1"
      style="margin-top: 30px"
      :n="lastPage"
      :max="3"
      :last-page.sync="lastPage"
      :page="$route.query.page || 1"
    />
  </div>
</template>

<script>
import Pagination from "./Pagination";
// import "@/style/table.scss";
import InlineSvg from "vue-inline-svg";

export default {
  name: "TheTablePanelSupport",
  components: { Pagination, InlineSvg },
  data() {
    return {
      tickets: [],
      lastPage: 1,
    };
  },
  computed: {
    statusLabel() {
      const a = {
        OPENED: "باز",
        PENDING: "در حال بررسی",
        CUSTOMER_ANSWERED: "پاسخ شما",
        ADMIN_ANSWERED: "پاسخ ادمین",
      };
      return (e) => a[e];
    },
    statusColor() {
      const a = {
        OPENED: "var(--green)",
        PENDING: "var(--yellow)",
        CUSTOMER_ANSWERED: "var(--yellow",
        ADMIN_ANSWERED: "var(--sell)",
      };
      return (e) => a[e];
    },
    typeLabel() {
      const a = {
        TECHNICAL: "فنی",
        GENERAL: "عمومی",
      };
      return (e) => a[e];
    },
  },
  methods: {
    async getTickets() {
      this.state.loading = true;
      let query = {
        size: this.$route.query.perPage || 10,
        page: this.$route.query.page || 1,
      };
      const res = await this.$axios.get("/tickets", {
        params: query,
      });
      this.tickets = res.content;
      this.lastPage = res.totalPages;
    },
    goto(e) {
      this.$router.push("/dashboard/support/massage/" + e);
    },
  },
  mounted() {
    this.getTickets();
  },
};
</script>

<style lang="scss">
table {
  width: 100%;
  td {
    text-align: center;
  }
}
a:hover {
  color: var(--yellow);
}
.mobilehidden {
  @media (max-width: 600px) {
    display: none !important;
  }
}
</style>
